import request from "@/utils/request";

export function saveEnquiry(data) {
  return request({
    url: "/mgr/enquiry/saveEnquiry",
    method: "post",
    data,
  });
}

export function getListEnquiry(stockItemID) {
  return request({
    url: "/mgr/enquiry/getListEnquiry",
    method: "post",
    params: { stockItemID },
  });
}
